import { UserContextProps } from "@/contexts/UserContext/types";
import { ActionTypes } from "@/internals/constants/actionTypes";
import { UserProps } from "./user";
import { RestApiRequest } from "@/services/ApiConversorService/types/types";

export const PENDING_ACTION = "pendingAction";
export const PENDING_ACTION_FALLBACK = "pending_action_fallback";

export interface BasePendingAction {
  redirectTo: string;
}

export interface SelectPlanAction extends BasePendingAction {
  type: ActionTypes.SELECT_PLAN;
  payload: {
    userContext?: UserContextProps;
    user?: UserProps;
    selectedPlanId?: string;
    planId?: string;
  };
}

export interface UnauthorizedAccessAction extends BasePendingAction {
  type: ActionTypes.UNAUTHORIZED_ACCESS;
}

export interface EditorLoginAction extends BasePendingAction {
  type: ActionTypes.EDITOR_LOGIN;
}

export interface SaveDataOfLoggedUsers extends BasePendingAction {
  type: ActionTypes.SAVE_DATA_OF_LOGGED_USERS;
  payload: {
    qrId: string;
    data: {
      payload: RestApiRequest<any>;
      newData: any;
    };
  };
}

export interface OnNextButtonAction extends BasePendingAction {
  type: ActionTypes.ON_NEXT_BUTTON;
}

export interface OnPreviewModalAction extends BasePendingAction {
  type: ActionTypes.PREVIEW_MODAL;
}

export interface OnTogglePreviewAction extends BasePendingAction {
  type: ActionTypes.TOGGLE_PREVIEW;
}

export interface OnEditQRAction extends BasePendingAction {
  type: ActionTypes.EDIT_QR;
  payload: {
    qrId: string;
  };
}

export interface OnDownloadQRAction extends BasePendingAction {
  type: ActionTypes.DOWNLOAD_QR;
  payload: {
    qrCodeReference: string;
  };
}

export type PendingAction =
  | SelectPlanAction
  | UnauthorizedAccessAction
  | EditorLoginAction
  | SaveDataOfLoggedUsers
  | OnNextButtonAction
  | OnPreviewModalAction
  | OnTogglePreviewAction
  | OnDownloadQRAction
  | OnEditQRAction;
